import { useLocation } from "react-router-dom";

// A custom hook that builds on useLocation to parse
export function useGetSeachParam(name) {
  return new URLSearchParams(useLocation().search).get(name);
}

export function useSetSearchParam(name, value) {
  const searchParams = new URLSearchParams(useLocation().search);
  searchParams.set(name, value);
  return searchParams.toString();
}

export function useDeleteSearchParam(name) {
  const searchParams = new URLSearchParams(useLocation().search);
  searchParams.delete(name);
  return searchParams.toString();
}
